const env = import.meta.env;

// ============================================
// API Configuration (Definitive Fix)
// ============================================

// The value for `VITE_API_BASE_URL` is injected at build time by `vite.config.ts`.
export const API_BASE_URL = env.VITE_API_BASE_URL || '';

console.log(`✅ [Config] API_BASE_URL initialized to: "${API_BASE_URL}"`);

// --- Environment-Managed Exports ---
// Values are now correctly and securely loaded from environment variables.
export const PAYPAL_CLIENT_ID = env.VITE_PAYPAL_CLIENT_ID || '';
export const PLATFORM_FEE_PERCENT = Number(env.VITE_PLATFORM_FEE_PERCENT || 5);
export const PLATFORM_WALLET_ADDRESS =
  env.VITE_PLATFORM_WALLET_ADDRESS || 'PLATFORM_WALLET_ADDRESS_PLACEHOLDER';
export const PLATFORM_BANK_ACCOUNT =
  env.VITE_PLATFORM_BANK_ACCOUNT || 'PLATFORM_BANK_ACCOUNT_PLACEHOLDER';

if (!PAYPAL_CLIENT_ID) {
  console.warn('[Config] Warning: VITE_PAYPAL_CLIENT_ID is not set in the environment.');
}
